var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { switchMap, tap } from 'rxjs/operators';
import { MatDialog } from '@angular/material';
import { ConformationDialogComponent } from './conformation-dialog.component';
import { isNil } from 'lodash';
import { AuthenticationService } from '@synisys/idm-authentication-client-js';
var WarningOnLeaveGuard = /** @class */ (function () {
    function WarningOnLeaveGuard(dialog, authenticationService) {
        this.dialog = dialog;
        this.authenticationService = authenticationService;
    }
    WarningOnLeaveGuard.prototype.canDeactivate = function (monitoredContainer, currentRoute, currentState, nextState) {
        var _this = this;
        if (isNil(monitoredContainer) ||
            isNil(monitoredContainer.deContainer) ||
            isNil(monitoredContainer.deContainer.form)) {
            return Observable.of(true);
        }
        var isAtSameUrl = this.isAtSameUrl(currentState, nextState);
        var monitoredForm = !monitoredContainer.deContainer.isToggled
            ? monitoredContainer.deContainer.form
            : monitoredContainer.deContainer.drawerForm.drawerContainer.form;
        return monitoredForm
            ? monitoredForm
                .noChanges()
                .first()
                .pipe(switchMap(function (noChanges) {
                if (!noChanges) {
                    return _this.dialogOpening(monitoredForm, isAtSameUrl);
                }
                else if (isAtSameUrl) {
                    return Observable.of(true).pipe(tap(function (_) {
                        monitoredForm.cleanEntity();
                    }));
                }
                return Observable.of(true);
            }))
            : Observable.of(true);
    };
    WarningOnLeaveGuard.prototype.dialogOpening = function (monitoredForm, urlDidntChanged) {
        var _this = this;
        return this.authenticationService.isLoggedOn().pipe(switchMap(function (isLogged) {
            if (isLogged) {
                var dialogRef = _this.dialog.open(ConformationDialogComponent);
                return dialogRef.afterClosed().pipe(tap(function (result) {
                    if (urlDidntChanged && result) {
                        monitoredForm.resetEntity();
                    }
                }));
            }
            else {
                return Observable.of(true);
            }
        }));
    };
    WarningOnLeaveGuard.prototype.isAtSameUrl = function (currentState, nextState) {
        if (!isNil(nextState)) {
            return (nextState.url.split('#')[0] === currentState.url.split('#')[0]);
        }
        return false;
    };
    WarningOnLeaveGuard = __decorate([
        Injectable(),
        __metadata("design:paramtypes", [MatDialog,
            AuthenticationService])
    ], WarningOnLeaveGuard);
    return WarningOnLeaveGuard;
}());
export { WarningOnLeaveGuard };
//# sourceMappingURL=warning-on-leave.guard.js.map